import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import React from 'react'

import { Button } from '../Button'

const Slideout = ({ content, description, loading, onSave, open, setOpen, title }) => (
  <Dialog open={open} onClose={setOpen} className="relative z-10">
    <DialogBackdrop
      transition
      className="data-closed:opacity-0 fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out"
    />

    <div className="fixed inset-0 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
          <DialogPanel
            transition
            className="data-closed:translate-x-full pointer-events-auto w-screen max-w-md transition duration-500 ease-in-out sm:duration-700"
          >
            <div className="flex h-full flex-col bg-white shadow-xl">
              <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-xl font-semibold text-gray-900">
                      {title}
                    </DialogTitle>

                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="focus-visible:outline-hidden text-purple hover:text-primary-dark bg-purple relative rounded-md"
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon aria-hidden="true" className="fill-purple size-6" />
                      </button>
                    </div>
                  </div>

                  {description && <p className="text-sm text-gray-500">{description}</p>}
                </div>

                {content}
              </div>

              <div className="flex shrink-0 justify-end gap-3 p-4">
                <Button
                  background="bg-background"
                  loading={loading}
                  onClick={() => setOpen(false)}
                  outlined
                  label="Cancel"
                  size="sm"
                />

                <Button onClick={onSave} label="Save" loading={loading} size="sm" />
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>
)

Slideout.propTypes = {
  content: PropTypes.node.isRequired,
  description: PropTypes.string,
  loading: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
}

export default Slideout
